import { FC, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import ImageSlider from 'modules/shared/components/ImageSlider/ImageSlider';
import { ICameraImage } from '@api/models';

const sliderAnimation = {
    variants: { hidden: { y: '200px' }, visible: { y: 0 } },
    transition: { duration: 0.35 },
    initial: 'hidden',
    animate: 'visible',
    exit: 'hidden',
};

interface OverlayImageSliderProps {
    show: boolean;
    onClose: () => void;
    images: ICameraImage[];
    selectedImage: ICameraImage;
    onSelectedImageChange: (image: ICameraImage) => void;
    selectedDate: string;
    onSelectedDateChange: (date: string) => void;
    startDate: string;
    endDate: string;
    isLoading: boolean;
}

const OverlayImageSlider: FC<OverlayImageSliderProps> = ({
    show,
    onClose,
    images,
    selectedImage,
    onSelectedImageChange,
    selectedDate,
    onSelectedDateChange,
    startDate,
    endDate,
    isLoading,
}) => {
    const sliderRef = useRef<HTMLDivElement | null>(null);

    return (
        <AnimatePresence initial={false} mode="wait">
            {show && (
                <>
                    {/* Backdrop that closes the slider */}
                    <div className="fixed inset-0 z-[69] bg-black/30 md:bg-transparent" onClick={onClose} />

                    {/* Slider panel: fixed on mobile, absolute on md+ */}
                    <motion.div
                        {...sliderAnimation}
                        className="fixed md:absolute z-[70] bottom-0 left-0 right-0"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <ImageSlider
                            ref={sliderRef}
                            className="bg-background-color md:bg-background-color/60"
                            images={images}
                            selectedImage={selectedImage}
                            onSelectedImageChange={onSelectedImageChange}
                            selectedDate={selectedDate}
                            onSelectedDateChange={onSelectedDateChange}
                            startDate={startDate}
                            endDate={endDate}
                            isLoading={isLoading}
                        />
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default OverlayImageSlider;
